const useButtonStyles = (type) => {
  let bgColor,
    borderColor,
    textColor,
    hoverBgColor,
    hoverBorderColor,
    hoverTextColor,
    activeBgColor,
    activeBorderColor,
    activeTextColor;

  switch (type) {
    case "default":
    default:
      bgColor = "gray-50 dark:bg-gray-800";
      borderColor = "lg:blue-300 lg:dark:border-blue-700";
      textColor = "black dark:text-white";
      hoverBgColor = "blue-200 dark:hover:border-blue-800";
      hoverBorderColor = "blue-500 dark:hover:border-blue-500";
      hoverTextColor = "black dark:text-white";
      activeBgColor = "blue-500 dark:bg-blue-600";
      activeBorderColor = "lg:blue-800 lg:dark:border-blue-300";
      activeTextColor= "gray-50 dark:text-gray-800";
  }
 
  const baseClass = ` bg-${bgColor} border-${borderColor} text-${textColor} `
  const hoverClass = ` hover:bg-${hoverBgColor} hover:border-${hoverBorderColor} hover:text-${hoverTextColor} `
  const activeClass = ` bg-${activeBgColor} border-${activeBorderColor} text-${activeTextColor} font-medium `
  return {
   baseClass,
   hoverClass,
   activeClass
  };
};

export const Button = ({
  children,
  onClick,
  isActive,
  type = "default",
  rounded = true,
  className=""
}) => {
  const {
    baseClass,
    hoverClass,
    activeClass
  } = useButtonStyles(type);
  return (
    <div
      className={
        `font-regular  cursor-pointer lg:border  shadow-sm p-2 flex flex-col items-center justify-center ${className} ` +
        `${hoverClass} ` +
        (isActive
          ? activeClass
          : baseClass) +
        (rounded && " rounded-none lg:rounded-md")
      }
      onClick={onClick}
    >
      {children}
    </div>
  );
};
